import React, {useEffect, useState} from "react";

/* MODAL */
import {useModal} from 'hooks/modalContext';
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

export default function CheckListAdd(props) {

  //전역
  const {closeModal} = useModal();
  const [title, setTitle] = useState('');
  const [result, setResult] = useState({
    custMstSeq: '',
    checkName: '',
    qrCode: '',
  });

  //고객사 방역 구역 정보 조회
  const [clientDetailList, setClientDetailList] = useState([]);
  const getClientDetailList = custMstSeq => {
    Server.sendGet(
      'client/check/list/patrol',
      {
        custMstSeq: custMstSeq
      },
      getClientDetailListCallback
    ).then();
  }
  const getClientDetailListCallback = res => {
    setClientDetailList(res['resultList']);
  }

  useEffect(() => {
    getClientDetailList(props.props.data.item?.clientKey.custMstSeq);
    setTitle(props.props.data.item?.clientKey.clientName);
    setResult(() => {
      return {
        ...result,
        custMstSeq: props.props.data.item?.clientKey.custMstSeq,
      }
    })
  }, [props.props.data.item]);

  //select 선택값 변경
  const changeQrCodeValue = patrolAreaNfcKey => {
    setResult(() => {
      return {
        ...result,
        qrCode: patrolAreaNfcKey,
      }
    })
  }

  //input 값 변경
  const changeCheckNameValue = checkName => {
    setResult(() => {
      return {
        ...result,
        checkName: checkName,
      }
    })
  }

  //등록
  const insertClientCheckList = () => {
    console.log(result);
    if(result.custMstSeq === '') {
      Common.errorMsg('고객사 정보가 유실되었습니다. \n 팝업 종료 후 다시 진행해주세요.');
      return;
    } else if(result.checkName === '') {
      Common.errorMsg('업무명을 입력해주세요.');
      return;
    } else if(result.qrCode === '') {
      Common.errorMsg('연결할 방역 구역을 선택해주세요.');
      return;
    }

    Server.sendPost('client/check/list', result, insertClientCheckListCallback).then();
  }
  const insertClientCheckListCallback = res => {
    Common.alertSuccess();
    props.props.data.callback(result.custMstSeq);
    closeModal();
  }

  return (
    <>
      <div className='modal-box'>
        <div className='inner'>
          <div className='modal-head'>
            <i/>
            <h4><span style={{color: "#0072B9"}}>{title}</span> CheckList Management</h4>
          </div>
          <div className='modal-content'>
            <table>
              <colgroup>
                <col width='40%'/>
                <col width='60%'/>
              </colgroup>
              <thead>
              <tr>
                <th>Work</th>
                <th>QR Code</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <input
                    type='text'
                    name='work-tit'
                    id='work-tit'
                    onChange={e => changeCheckNameValue(e.target.value)}
                  />
                </td>
                <td>
                  <select
                    onChange={e => changeQrCodeValue(e.target.value)}
                  >
                    <option value=''>-- select --</option>
                    {clientDetailList?.map((item, idx) => (
                      <option value={item['patrolAreaNfcKey']}>{item['patrolArea']}</option>
                    ))}
                  </select>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div className='edit-btn'>
            <button
              className='submit'
              onClick={insertClientCheckList}
            >Submit</button>
            <button className='cancel' onClick={closeModal}>Cancel</button>
          </div>
        </div>
      </div>
    </>
  )
}
